import { Actioner } from "@services/actioner";
import {
	type ArrayProductResult,
	type Campaign,
	PlanSummary,
	type PlanSummaryResult,
	Product,
	Result,
} from "@services/sdk/models";
import ErrorResponseFactory from "@services/sdk/models/error-response-factory";
import type { ID } from "@services/sdk/types";
import type { AxiosInstance } from "axios";

export const createMRTMProductsAdapter = (httpClient: AxiosInstance) => ({
	async getProducts(event = "BUY"): Promise<ArrayProductResult> {
		try {
			const response = await httpClient.get("/products", {
				params: {
					event,
				},
			});

			return Result.Success(Product.ConstructList(response.data.data.items));
		} catch (err: any) {
			Actioner.trigger(Actioner.keyDefs.ERROR, err);
			return Result.Failure(ErrorResponseFactory.ErrorGetProducts(err));
		}
	},

	async getPlanSummary(
		productIds: Array<ID>,
		promoCode: Campaign | null,
		event = "BUY",
		simChannel = "NON_RETAIL",
		simType = "PHYSICAL",
		simProductId: number | null,
		planUpgrade = false,
	): Promise<PlanSummaryResult> {
		try {
			const filteredIDs = productIds.filter(
				(id) => id !== null && id !== undefined,
			);
			const productsQueryParam = filteredIDs.toString();
			const promoCodeQueryParam = promoCode ? promoCode.code : "";
			const response = await httpClient.get("/payment/total", {
				params: {
					products: productsQueryParam,
					code: promoCodeQueryParam,
					event,
					simChannel,
					simType,
					simProductId,
					planUpgrade,
				},
			});

			const planSummaryResponseData = response.data.data;

			return Result.Success(PlanSummary.Construct(planSummaryResponseData));
		} catch (err: any) {
			Actioner.trigger(Actioner.keyDefs.ERROR, err);
			return Result.Failure(ErrorResponseFactory.ErrorGetPlanSummary(err));
		}
	},
});
